<template>
  <el-dialog
    v-dialogDrag
    :title="`从Excel导入`"
    :visible.sync="uploadFileProps.visible"
    :close-on-click-modal="false"
    width="760px"
    class="small-dialog"
    append-to-body
  >
    <el-steps
      finish-status="success"
      :active="uploadFileProps.active"
      class="mt-20px"
      align-center
    >
      <el-step
        class="text-14px"
        :title="`下载模板`"
        @click="downloadTemplate"
      ></el-step>
      <el-step :title="`上传文件`"></el-step>
      <el-step :title="`完成`"></el-step>
    </el-steps>
    <div v-if="uploadFileProps.active === 0">
      <div class="text-center mt-76px">
        <div class="upload-demo">
          <div
            class="
              el-upload el-upload--text
              down-text
              border border-dashed border-neutral-300
              rounded
              w-490px
              h-244px
            "
          >
            <div class="mt-70px">
              <i
                @click="downloadTemplate"
                class="
                  icon
                  iconfont
                  icon-bg-excel
                  h-full
                  text-50px
                  blue-700
                  text-color-system
                "
              ></i>
              <!-- text-blue-500 -->
              <div class="el-upload__text mt-10px">
                {{ `点击图标下载模板，填写信息，如已下载完成,点击` }}
                <em class="text-color text-color-system" @click="nextStep">
                  {{ `下一步` }}</em
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="uploadFileProps.active === 1"
      class="text-center mt-76px mb-4px"
    >
      <el-upload
        v-loading="uploadFileProps.btnLoading"
        ref="upload"
        drag
        action="https://xx.yy.zz"
        :show-file-list="false"
        :before-upload="getFileContent"
        :http-request="uploadExcel"
        :multiple="false"
        class="dialog__upload"
      >
        <i
          class="el-icon-upload text-67px blue-700 text-color-system !mt-70px"
        ></i>
        <div class="el-upload__text">
          {{ `一次只能上传一个文件，或` }}
          <em> {{ `点击上传` }}</em>
        </div>
      </el-upload>
    </div>
    <div class="padding-1" v-show="uploadFileProps.active === 2">
      <div class="text-center mt-76px">
        <div class="upload-demo">
          <div class="el-upload el-upload--text down-text">
            <div class="mt-25px pt-20px">
              <div
                class="mt-30px flex items-center"
                v-if="
                  uploadFileProps.resultFile !== undefined &&
                  uploadFileProps.resultFile !== ''
                "
              >
                <i
                  class="iconfont icon-line-complete text-24px text-green-500"
                ></i>
                <span class="text-20px ml-10px mr-10px">
                  {{
                    `上传成功！成功${uploadFileProps.successCount}条，失败${uploadFileProps.failureCount}条`
                  }}
                </span>
                <el-button size="mini" type="primary" @click="exportResults"
                  >查看导入结果</el-button
                >
              </div>
              <div
                class="el-upload__text"
                v-else-if="
                  uploadFileProps.resultFile === undefined ||
                  uploadFileProps.resultFile === ''
                "
              >
                <div class="mt-25px pt-20px">
                  <span class="mt-30px">
                    <i
                      class="
                        iconfont
                        icon-line-complete
                        text-54px text-green-500
                      "
                    ></i>
                  </span>
                  <div class="el-upload__text">
                    {{ `上传成功` }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="text-center">
      <el-button
        v-if="uploadFileProps.active === 1"
        type="primary"
        size="small"
        @click="uploadFileProps.active = 0"
        :loading="uploadFileProps.btnLoading"
      >
        {{ `上一步` }}</el-button
      >
      <el-button
        v-if="uploadFileProps.active === 2"
        type="primary"
        size="small"
        @click="closeDialog"
        :loading="uploadFileProps.btnLoading"
        >{{ `完成` }}</el-button
      >
      <el-button
        v-if="uploadFileProps.active === 0"
        type="primary"
        size="small"
        @click="nextStep"
        :loading="uploadFileProps.btnLoading"
        >{{ `下一步` }}</el-button
      >
      <el-button
        @click="uploadFileProps.active = 1"
        v-if="uploadFileProps.active === 2"
        size="small"
        >{{ `上一步` }}</el-button
      >
      <el-button
        @click="closeDialog"
        v-if="uploadFileProps.active !== 2"
        size="small"
        :loading="uploadFileProps.btnLoading"
      >
        {{ `取消` }}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "wiz-upload-file",

  props: {
    /**
     * @param {控制弹窗显示隐藏} visible
     * @return {*}
     */
    uploadFileProps: {
      type: Object,
      default: () => {
        return {
          visible: false,
          active: 1,
          btnLoading: false,
          isTestAndVerify: false,
          type: [],
        };
      },
    },
  },
  data() {
    return {
      file: "",
      suffix: false,
    };
  },
  watch: {},
  methods: {
    // 下载模板
    async downloadTemplate() {
      this.$emit("exportTemplate");
    },
    // 下一步
    nextStep() {
      this.uploadFileProps.active += 1;
      if (this.uploadFileProps.active > 2) {
        this.uploadFileProps.active = 1;
      }
    },
    // 获取上传的内容并校验格式
    getFileContent(file) {
      this.file = file;
      if (this.uploadFileProps.isTestAndVerify) {
        const format = file.name.substring(file.name.lastIndexOf(".") + 1);
        this.uploadFileProps.type.forEach((item) => {
          if (format === item) {
            this.suffix = true;
          }
        });
        if (!this.suffix) {
          this.$message.error(
            `文件格式错误，请上传${this.uploadFileProps.type.join()}文件`
          );
          return false;
        }
      }
      return this.suffix;
    },
    // 上传
    async uploadExcel() {
      if (this.suffix) {
        this.$emit("importTemplate", this.file);
      }
    },
    exportResults() {
      this.$emit("exportResults");
    },
    // 关闭弹窗并重新请求列表
    closeDialog() {
      this.$emit("refreshList");
      this.uploadFileProps.active = 1;
      this.file = "";
      this.uploadFileProps.visible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.dialog__upload {
  ::v-deep .el-step.is-simple {
    .el-step__title {
      font-size: 15px !important;
    }
  }
  ::v-deep .el-upload-dragger {
    height: 244px !important;
    width: 490px !important;
  }
}
</style>
